module.exports = __webpack_public_path__ + "static/media/PlanoConta4.42854985.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadPlanoConta/PlanoConta4.png
// module id = 2203
// module chunks = 0